<template>
  <div class="infoList">
    <span class="infoListLeft">{{left}}</span>
    <span class="infoListRight" v-if="right">{{right}}</span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'List',
  props: ['left', 'right'],
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
  position: relative;
}
.infoListLeft {
  color: #1C2438;
  font-size: 14px;
}
.warn {
  color: #9ea7b4;
  font-size: 14px;
  font-size: 700;
  text-align: center;
}
.infoListRight {
  color: #495060;
  font-size: 14px;
}
</style>
